/**
 * @file Avatar component (for displaying account/identity selfies).
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getMinThumb, getThumbBySize } from '../../util/photo';
import {
  AVATAR_SIZE_18,
  AVATAR_SIZE_28,
  AVATAR_SIZE_36,
  AVATAR_SIZE_42,
  AVATAR_SIZE_52,
  AVATAR_SIZE_72,
  AVATAR_SIZE_96,
} from '../../constants/avatar-sizes';
import { IMAGE_SIZE_CODE } from '../../constants/image-size-codes';
import CheckmarkIcon from '../icons/CheckmarkIcon';

const propTypes = {
  photo: PropTypes.shape({
    thumbnail_urls: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string,
      }),
    ),
  }),
  size: PropTypes.oneOf([
    AVATAR_SIZE_18,
    AVATAR_SIZE_28,
    AVATAR_SIZE_36,
    AVATAR_SIZE_42,
    AVATAR_SIZE_52,
    AVATAR_SIZE_72,
    AVATAR_SIZE_96,
  ]),
  className: PropTypes.string,
  selected: PropTypes.bool,
  withCheckmark: PropTypes.bool,
};

const Avatar = ({
  photo,
  size = AVATAR_SIZE_36,
  className,
  selected,
  withCheckmark = true,
  ...props
}) => {
  const classes = classNames({
    avatar: true,
    [`avatar-${size}`]: true,
    [className]: !!className,
    'avatar-waldo': !photo || !photo.thumbnail_urls,
    'img-circle': photo && photo.thumbnail_urls,
    'avatar-selected': selected,
  });

  if (!photo || !photo.thumbnail_urls) {
    return <span className={classes} {...props} />;
  }

  const thumb =
    getThumbBySize(photo.thumbnail_urls, IMAGE_SIZE_CODE.SMALL2X) ||
    getMinThumb(photo.thumbnail_urls);

  return (
    <span className={classes}>
      <img src={thumb.url} alt="Avatar" {...props} />
      {selected && withCheckmark && (
        <div className="avatar-selected-icon">
          <CheckmarkIcon color="#fff" size="10" />
        </div>
      )}
    </span>
  );
};

Avatar.propTypes = propTypes;

export default Avatar;
